import './clickable.css';

function Clickable(props: ClickableProps ) {

    const handleClick = (url: string) => {    
        window.open(url)
    }

    return (
        <div className='clickable clickable_comp' onClick={() => handleClick(props.url)}>
            <img src={props.img} className={'clickable_img '+props.size} />
            {props.description && (<p>{props.description}</p>)}
        </div>
    );
}

interface ClickableProps {
    img: string,
    url: string,
    description?: string,
    size?: 'sm' | 'md' | 'lg'
}

export {Clickable, ClickableProps}